module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0109.png.9fb54b1d.jpg";